module.exports = __webpack_public_path__ + "static/media/kaguya.85325196.png";